export default __webpack_public_path__ + "static/media/terms-of-service-consent-kr-0.8c11f21b.jpg";